import React, {  useState } from 'react';
import './RoboTaxiPopup.css';

const RoboTaxiPopup = (props) => {
  //   const [customNumber, setCustomNumber] = useState(0);
  const [assignAll, setAssignAll] = useState(false);
  const totalSpaces = props.pslCount;

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    setAssignAll(checked);
    props.setRoboTaxiLimit(checked ? totalSpaces : 0);
    if (checked) {
      props.setRoboTaxiCountError(""); // Clear error as soon as input becomes valid
    }
  };

  const handleNumberChange = (e) => {
    const input = e.target.value;

    // Allow empty input (user clearing the field)
    if (input === '') {
      props.setRoboTaxiLimit('');
      setAssignAll(false);
      props.setRoboTaxiCountError("Please enter a valid RoboTaxi count.");

      return;

    }

    const value = Math.max(0, Math.min(totalSpaces, parseInt(input)));
    props.setRoboTaxiLimit(value);
    setAssignAll(value === totalSpaces);
    if (value === 0) {
      props.setRoboTaxiCountError("RoboTaxi count must be greater than 0.");
    } else {
      props.setRoboTaxiCountError(""); // Clear error as soon as input becomes valid
    }
  };



  return (
    <>
      {
        props.roboTaxiAlert && (

          <div className="popup-container">
            <div className="popup">
              <span className='heading-title'>Assign Spaces for RoboTaxis</span>
              <div className='popup-content-text'>
                <p><strong>You’ve marked {totalSpaces} parking spaces.</strong></p>
                <p>How many of these would you like to assign for RoboTaxi use?</p>
              </div>


              <div className="input-group">
                <label>Enter custom number:</label>
                <div className="number-input">
                  <input
                    type="number"
                    value={props.roboTaxiLimit === '' ? '' : props.roboTaxiLimit}
                    onChange={handleNumberChange}
                    disabled={assignAll}
                  />
                  <span>of {totalSpaces}</span>
                </div>
              </div>

              <p className="or">or</p>

              <div className="checkbox-group-RoboTaxi">
                <input
                  className='RoboTaxi-checkbox'
                  type="checkbox"
                  id="assignAll"
                  checked={assignAll || Number(props.roboTaxiLimit) === Number(props.pslCount)}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor="assignAll">Select all spaces for Robotaxis</label>
              </div>
              <div className='robotaxi-error' >{props.roboTaxiCountError}</div>

              <button className="add-property-btn"
                onClick={props.handleSaveLimit}
              >Save Limit</button>
            </div>
          </div>
        )
      }
    </>

  );
};

export default RoboTaxiPopup;

